import { useQuery } from "react-query";
import { QueryLoader } from "../Loader";
import { STable } from "../../styles/AdminSearchScore";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getOrganizations } from "../../api/superadmin/organizations";

/** One row per organization admin, for root. */
export default function OrganizationAdminsList() {
	const { axiosPrivate } = useAxiosPrivate();
	const { data = [], isLoading, isError } = useQuery("superadmin-organizations", () => getOrganizations(axiosPrivate));

	if (isLoading) return <QueryLoader />;
	if (isError) return <p>Organization admins could not be loaded.</p>;

	const rows = data.flatMap((organization) => organization.admins.map((admin) => ({ organization, admin })));
	return (
		<STable>
			<thead>
				<tr>
					<td colSpan={2}>Organization</td>
					<td colSpan={2}>Name</td>
					<td colSpan={2}>Email</td>
					<td>Status</td>
				</tr>
			</thead>
			<tbody>
				{rows.length === 0 ? (
					<tr>
						<td colSpan={7}>No organization admins found</td>
					</tr>
				) : (
					rows.map(({ organization, admin }) => (
						<tr key={admin.id}>
							<td colSpan={2}>{organization.name}</td>
							<td colSpan={2}>
								{admin.firstName} {admin.lastName}
							</td>
							<td colSpan={2} style={{ overflowWrap: "anywhere" }}>
								{admin.email}
							</td>
							<td>{admin.active ? "Active" : "Deactivated"}</td>
						</tr>
					))
				)}
			</tbody>
		</STable>
	);
}
